import { computed, Signal, signal } from "@angular/core";

export type ObservablePropertyStatus = "idle" | "loading" | "ready" | "error";

export class ObservableProperty<T>  
{
   private _value = signal<T>(undefined as T);
   private _status = signal<ObservablePropertyStatus>("idle");

   public isReady = computed(() => this._status() === "ready");

   public get value(): Signal<T> {
      return this._value;
   }

    public get status(): Signal<ObservablePropertyStatus> {
      return this._status;
    }

   public setValue(newValue: T): void {
      this._value.set(newValue);
   }

   public setStatus(newStatus: ObservablePropertyStatus): void {
      this._status.set(newStatus);
   }
}